import styled from '@emotion/styled';

export const SContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const STitle = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: rgba(0, 0, 0, 0.85);
  padding-left: 16px;
`;
